import React, { FunctionComponent } from "react";
import { PersonalTaxFormNavigation } from "./formNavigation/PersonalTaxFormNavigation";
import { PersonalTaxForm } from "./types";
import "./personalTaxPage.css";
import { CompanyBanner } from "./CompanyBanner";
import { PersonaliaForm } from "./personaliaForm/PersonaliaForm";
import { BurgerlijkeStaatForm } from "./burgerlijkeStaatForm/BurgerlijkeStaatForm";
import { AangiftecodesForm } from "./aangiftecodesForm/AangiftecodesForm";
import { GezinslastenForm } from "./gezinslastenForm/GezinslastenForm";
import { TaxCalculationResult } from "./taxCalculationResult/TaxCalculationResult";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { AangifteProvider } from "components/aangifte/AangifteProvider";
import { useSessionStorage } from "hooks/useSessionStorage";
import { Aangifte, aangifteToSeed, Seed } from "domain/aangifte";
import { pipe } from "fp-ts/lib/function";

export const PersonalTaxPage: FunctionComponent = () => {
  const [currentForm, setCurrentForm] = React.useState<PersonalTaxForm>("personalia");
  const companyName = useWhiteLabelSetting("name") as string;
  const [initialAangifte, save] = useSessionStorage<Seed>(companyName, {});

  const handleChange = React.useCallback(
    (aangifte: Aangifte) => {
      pipe(aangifte, aangifteToSeed, save);
    },
    [save]
  );

  return (
    <AangifteProvider initialAangifte={initialAangifte} onChange={handleChange}>
      <div className="tax-page">
        <PersonalTaxFormNavigation onChange={setCurrentForm} activeForm={currentForm} />
        <div className="bannercontainerwrapper">
          {currentForm !== "resultaat" && <CompanyBanner />}
          {(() => {
            switch (currentForm) {
              case "personalia":
                return <PersonaliaForm />;
              case "burgerlijksStaat":
                return <BurgerlijkeStaatForm />;
              case "aangiftecodes":
                return <AangiftecodesForm />;
              case "gezinslasten":
                return <GezinslastenForm />;
              case "resultaat":
                return <TaxCalculationResult />;
            }
          })()}
        </div>
      </div>
    </AangifteProvider>
  );
};

PersonalTaxPage.displayName = "PersonalTaxPage";
